import { exec, getApiToken } from '../utils';
import type {
  DetailsResult,
  GetParentSkuDetailsExecVariables,
  GetParentSkuDetailsExecResponse
} from '@src/types';

export const getParentSkuDetails = async ({
  parentSku,
  partnerCode,
  token
}: {
  parentSku: string;
  partnerCode: string;
  token: string;
}): Promise<DetailsResult> => {
  const apiToken = await getApiToken(token);

  const searchQuery = `
    query parentSkuDetails(
      $parentSku: String!
      $partnerCode: String!
      $token: String!
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          parentSkuDetails(
            parentSku: $parentSku
          ) {
            productName
            productDescription
            availability
            isInconsistentAvailability
            departments
            categories
            subcategories
            partnerCategory
            gender {
              code
              name
            }
            msrpPrice
            lastKnownRetailPrice
            taxCode
            brandDisplay
            rubricCode
            imagesByColorway
            studioImagesByColorway
            variants {
              colorCode
              colorDisplay
              variantCount
              skus
              sizeDisplays
              partnerImageUrls
              studioImageUrls
              otherVitalElements
            }
          }
        }
      }
    }
  `;

  const data = await exec<GetParentSkuDetailsExecVariables, GetParentSkuDetailsExecResponse>(
    searchQuery,
    {
      variables: {
        token: apiToken,
        partnerCode,
        parentSku,
      },
    }
  );
  return data.restUser.partner.parentSkuDetails;
};
